<template>
  <v-container>
    <v-row justify="center">
      <v-col cols="12"
             md="6">
        <base-material-card color="indigo"
                            icon="mdi-content-copy"
                            title="Edit template"
                            class="py-3 px-5">
          <v-form>
            <v-text-field color="secondary"
                          label="Description"
                          v-model="item.description" />

            <v-autocomplete v-model="item.courseTypeId"
                            :items="courses"
                            label="Course type"
                            item-text="description"
                            item-value="id" />

            <v-autocomplete v-model="item.productId"
                            :items="products"
                            label="Product" />

            <v-row>
              <v-col cols="6"
                     md="6">

                <h4>Customer tasks</h4>

                <v-container v-for="(task,k) in item.customerTasks" :key="k">
                  <v-row align="center">
                    <v-col cols="6">
                      <v-text-field label="Task name"
                                    v-model="task.name" />
                    </v-col>
                    <v-col cols="4">
                      <v-icon @click="removeCustomerTask(k)" v-show="k || (!k && item.customerTasks.length>1)">mdi-delete</v-icon>
                    </v-col>
                  </v-row>
                  <v-row>

                  </v-row>
                </v-container>
                <v-icon class="mb-5" @click="addCustomerTask()">mdi-plus</v-icon>

              </v-col>
              <v-col cols="6"
                     md="6">

                <h4>Course tasks</h4>

                <v-container v-for="(task,k) in item.trainingTasks" :key="k">
                  <v-row align="center">
                    <v-col cols="6">
                      <v-text-field label="Task name"
                                    v-model="task.name" />
                    </v-col>
                    <v-col cols="4">
                      <v-icon @click="removeTrainingTask(k)" v-show="k || (!k && item.trainingTasks.length>1)">mdi-delete</v-icon>
                    </v-col>
                  </v-row>
                  <v-row>

                  </v-row>
                </v-container>
                <v-icon class="mb-5" @click="addTrainingTask()">mdi-plus</v-icon>

              </v-col>
            </v-row>

            <ckeditor :editor="meditor" v-model="item.startMailTemplate"></ckeditor>


            <v-card-actions class="pa-0 mt-5">

              <v-spacer />

              <v-btn default
                     color="success"
                     @click="updateItem">
                Update
              </v-btn>
            </v-card-actions>
          </v-form>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import router from '../../../router';
  import CKEditor from '@ckeditor/ckeditor5-vue';
  import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
  import axios from "../../../utils/axios";

  import TrainingTemplate from '../../../servcies/api/training/TrainingTemplate'
  import TrainingType from '../../../servcies/api/training/TrainingType'


  export default {

    name: 'TrainingTemplateEdit',

    components: {
      ckeditor: CKEditor.component
    },

    data: () => ({

      meditor: ClassicEditor,
      content: null,
      id: null,
      item: null,
      courses: [],
      isEdit: false,
      tasks: [],
      products: [],
    }),

    created() {
      this.id = this.$route.params.id;
      if (this.$route.params.id != undefined) {
        this.id = this.$route.params.id;
        this.init();
      }
    },
    methods: {

      updateItem() {
        let loader = this.$loading.show();
        var data = this.item;
        TrainingTemplate.updateTemplate(data.id, data)
          .then((result) => {
            this.back();
            loader.hide();
          }).catch((err) => {
            console.log(err)
            loader.hide();
          });
      },
      addTrainingTask() {
        this.item.trainingTasks.push({ name: '' })
      },
      removeTrainingTask(index) {
        this.item.trainingTasks.splice(index, 1)
      },
      addCustomerTask() {
        this.item.customerTasks.push({ name: '' })
      },
      removeCustomerTask(index) {
        this.item.customerTasks.splice(index, 1)
      },

      back() {
        router.go(-1);
      },

      async init() {
        this.getTemplate(this.id)
        this.getCourses()
        await this.getProducts()
      },




      //Get Data
      getTemplate(id) {
        let loader = this.$loading.show();
        TrainingTemplate.getTemplate(id)
          .then((result) => {
            this.item = result
            loader.hide();
          }).catch((err) => {
            console.log(err)
            loader.hide();
          });
      },
      
      getCourses() {
        let loader = this.$loading.show();
        TrainingType.getCourses()
          .then((result) => {
            this.courses = result
            loader.hide();
          }).catch((err) => {
            console.log(err)
            loader.hide();
          });
      },
      async getProducts() {
        let loader = this.$loading.show();
        try {
          var result = await axios.get("/Product");
          if (result) {
            this.products = result.data.map((x) => {
              return { value: x.id, text: `${x.name} ${x.articleNumber}` }
            });
            this.addProductQuantity();
          } else {
            throw "Unknown error";
          }
        } catch (exception) {
          this.message = exception;
          this.snackbar = true;
        } finally {
          loader.hide();
        }
      },

    }

  }
</script>

<style>
  .ck-content {
    height: 500px;
  }
</style>
